import { render } from "./WidgetNotifications.vue?vue&type=template&id=7f738148"
import script from "./WidgetNotifications.vue?vue&type=script&lang=js"
export * from "./WidgetNotifications.vue?vue&type=script&lang=js"

import "./WidgetNotifications.vue?vue&type=style&index=0&id=7f738148&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__